import { SidebarInset } from '@9b3kuq5phwuk4txw/kiban-react-ui/primitives'
import { OpportunitiesSidebar } from '@opportunities/-components/OpportunitiesSidebar'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'

export const Route = createFileRoute('/_authenticated/opportunities')({
  component: OpportunitiesLayout,
})

function OpportunitiesLayout() {
  useDocumentTitle('オポチュニティ管理')
  return (
    <div className='flex h-full'>
      <OpportunitiesSidebar />
      <SidebarInset className='flex-1 h-full min-w-0'>
        <Outlet />
      </SidebarInset>
    </div>
  )
}
